/**
 * Teams 안에서 열렸을 때(개인 탭 ?inTeams=1): 쿠키 로그인 대신 Teams가 주는 사용자 토큰으로 API를 부른다.
 * Teams 탭은 teams.microsoft.com 안의 iframe이라 SameSite 쿠키가 실리지 않는다 —
 * 쿠키 보안 설정을 풀지 않고, 요청마다 토큰(대상: Workspace API)을 붙이는 방식을 쓴다.
 */
let ready = null;
export const inTeams = () => new URLSearchParams(window.location.search).get('inTeams') === '1';

// Teams SDK는 Teams 안에서만 필요하다 — 일반 브라우저 사용자에게는 내려보내지 않는다(지연 로드)
export function initTeams() {
  if (!ready) ready = import('@microsoft/teams-js').then(async (sdk) => { await sdk.app.initialize(); return sdk; });
  return ready;
}

/** Teams SDK가 캐시·갱신하는 토큰. 실패하면 호출부가 안내 화면을 띄운다 */
export async function teamsToken() {
  const sdk = await initTeams();
  return sdk.authentication.getAuthToken();
}

/**
 * 바깥 링크 열기(Teams 채팅 링크·서비스 등). Teams 탭(iframe) 안에서는 Teams가 열어야 채팅 링크가 Teams 안에서 열린다.
 * 브라우저에서는 새 창.
 */
export async function openExternal(url) {
  if (inTeams()) {
    const sdk = await initTeams();
    await sdk.app.openLink(url);
    return;
  }
  window.open(url, '_blank', 'noopener');
}

/** Teams 1:1·그룹 채팅 링크(받는 사람 메일 목록) */
export const teamsChatUrl = (emails) => `https://teams.microsoft.com/l/chat/0/0?users=${emails.map(encodeURIComponent).join(',')}`;

/** Teams 대화창으로 열렸는가(봇·메시지 확장이 연 웹 대화창 — ?dialog=1, 계획 문서 5.8) — 셸 장식 없이 화면만 */
export const dialogMode = () => inTeams() && new URLSearchParams(window.location.search).get('dialog') === '1';
/** 팀·그룹 채팅 탭 구성 화면(?teamsConfig=1) */
export const teamsConfigMode = () => inTeams() && new URLSearchParams(window.location.search).get('teamsConfig') === '1';

/** 탭 딥링크로 들어온 화면(context.page.subPageId = 딥링크의 subEntityId, 예: 'approval/<id>'). 없으면 null */
export async function teamsSubPage() {
  if (!inTeams()) return null;
  const sdk = await initTeams();
  const ctx = await sdk.app.getContext();
  return ctx?.page?.subPageId || null;
}

/** 대화창 닫기(보낼 값 없이) */
export async function closeDialog() {
  const sdk = await initTeams();
  sdk.dialog.url.submit();
}
